import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "what-should-i-ask-during-a-depression-treatment-consultation",
  title: "What Should I Ask During a Depression Treatment Consultation?",
  description:
    "Prepare for your depression treatment consultation with these key questions. Knowing what to ask helps you make an informed decision about your care.",
  keywords:
    "depression treatment consultation questions, what to ask, TMS consultation, treatment evaluation questions",
  badge: "Educational Article",
  heroTitle: "What Should I Ask During a Depression Treatment Consultation?",
  heroSubtitle:
    "A consultation is a two-way conversation. Coming prepared with questions helps you get the information you need to make an informed decision.",
  sections: [
    {
      heading: "Questions About the Treatments",
      body: "Ask which treatments may be appropriate for your situation and why. Ask how each works, what the evidence supports, and what the differences are between options.",
    },
    {
      heading: "Questions About Eligibility",
      body: "Ask what determines whether you're a candidate. Ask about your specific history — prior medications, prior TMS, current conditions — and how each factor is considered.",
    },
    {
      heading: "Questions About the Experience",
      body: "Ask what treatment feels like, how long sessions take, what side effects are possible, and what the daily commitment looks like for each option.",
    },
    {
      heading: "Questions About Cost and Insurance",
      body: "Ask whether your insurance may cover treatment, what prior authorization involves, and what your out-of-pocket cost may be. Ask about self-pay options if relevant.",
    },
    {
      heading: "Questions About What Comes Next",
      body: "Ask what happens after the consultation, what the timeline looks like, and what you need to prepare. Ask what happens after treatment ends, including maintenance and follow-up.",
      callout: true,
    },
  ],
  faq: [
    {
      question: "Do I need to bring anything to the consultation?",
      answer:
        "A rough list of medications you've tried and what happened is helpful. You don't need complete records for the first conversation — we can gather details as the process moves forward.",
    },
    {
      question: "Can I bring a family member to the consultation?",
      answer:
        "With your consent, family members may participate. We encourage involving loved ones when it's helpful to you.",
    },
  ],
  related: [
    {
      title: "What Happens During a Consultation",
      href: "/depression-treatment-consultation",
    },
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
    { title: "Depression Treatment FAQ", href: "/depression-treatment-faq" },
  ],
  finalCtaText:
    "Your questions matter. Speak with our team — we're here to answer them, not to pressure you.",
});
